module.exports = __webpack_public_path__ + "static/moonpig_colour-9c8e101735147cec92eddc41f2520272.png";